module.exports = __webpack_public_path__ + "img/金属材料学7_7.296e9cf6.png";